import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../../../../styledComponents/styles/Paragraph.styled';
import StyledIcon from '../../../../../styledComponents/styles/Icon.styled';
import { Col, Row } from '../../../../../styledComponents/styles/FlexGrid.styled';
import { Table, TableBody, TableRow, TableColumn } from '../../../../../styledComponents/styles/Table.styled';

const Container = styled.div`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #373737;
`;

const FileItem = styled.span`
  color: #043544;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  overflow-wrap: anywhere;
`;

const DownloadFile = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.06em;
  text-decoration-line: underline;
  color: #646464;
  margin-left: 5px;
`;

const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

const Label = styled.label`
  color: ${({ theme }) => theme.textInput.label.fontColor};
  font-family: ${({ theme }) => theme.textInput.label.fontFamily};
  font-size: ${({ theme }) => theme.textInput.label.fontSize};
  font-weight: ${({ theme }) => theme.textInput.label.fontWeight};
`;

const PreviewIcon = styled.span`
  color: #646464;
  cursor: not-allowed;
  justify-self: center;
  margin-left: 5px;
`;

const Required = styled.span`
  color: ${({ theme }) => theme.defaults.errorColor};
  padding-left: 5px;
`;

const FileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AttachmentTable = styled(Table)`
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #cccccc;

  th:first-child,
  tr:first-child {
    width: 70%;
  }

  td:first-child {
    width: 70%;
  }

  tr:nth-of-type(even) {
    background-color: #f6f7f9;
    border: 1px solid #c2c2c2;
    color: #646464;
    cursor: not-allowed;
  }

  tr:nth-of-type(odd) {
    background-color: #f6f7f9;
    border: 1px solid #c2c2c2;
    color: #646464;
    cursor: not-allowed;
  }
`;

const ImageNameSpanUnlink = styled.span`
  padding-left: 0px;
`;

const RowStyle = styled(Row)`
  padding-bottom: 8px;
`;

export const PreviewColumn = styled.td`
  width: 20px;
`;

export default function QuestionFileDownloadDisplayPreview({ question }) {
  const updatedInstruction = !!question.instructions ? question.instructions.replace(/<p><\/p>/g, '<br />') : '';
  return (
    <Container>
      <InputContainer>
        <Label htmlFor={question.id}>
          {question.label}
          {question.required && <Required>*</Required>}
        </Label>
        <Paragraph
          aria-label={question.label}
          id="file-download-instructions"
          openSans
          dangerouslySetInnerHTML={{
            __html: updatedInstruction,
          }}
        />
      </InputContainer>
      {question.uploaded_files.length === 0 ? null : (
        <InputContainer>
          <Col size={4}>
            <RowStyle>
              <FileContainer>
                <AttachmentTable>
                  <TableBody>
                    {question.uploaded_files.map((file, index) => (
                      <TableRow key={`${file.id}-${file.filename}-${index}`}>
                        <TableColumn>
                          <FileItem>
                            <ImageNameSpanUnlink>{file.filename}</ImageNameSpanUnlink>
                          </FileItem>
                        </TableColumn>
                        <PreviewColumn>
                          {file.content_type &&
                            file.url &&
                            (file.content_type.toLowerCase().indexOf('pdf') > -1 ||
                              file.content_type.toLowerCase().indexOf('image') > -1) && (
                              <PreviewIcon>
                                <StyledIcon type="Eye" size="16px" />
                              </PreviewIcon>
                            )}
                        </PreviewColumn>
                        <TableColumn>
                          <PreviewIcon>
                            <StyledIcon type="File_download" size="16px" color="#646464" />
                            <DownloadFile>Download File</DownloadFile>
                          </PreviewIcon>
                        </TableColumn>
                      </TableRow>
                    ))}
                  </TableBody>
                </AttachmentTable>
              </FileContainer>
            </RowStyle>
          </Col>
        </InputContainer>
      )}
    </Container>
  );
}
